/** Production site URL — used for canonical, Open Graph, and JSON-LD. */
export const SITE_ORIGIN = 'https://quizter.club';

export const SITE_NAME = 'Quizter Club';

/** Absolute logo URL for Organization schema and og:image fallback. */
export const SITE_LOGO_URL = `${SITE_ORIGIN}/logo512.png`;

/** Default meta description (50–200 chars) for crawlers and Helmet fallback. */
export const DEFAULT_META_DESCRIPTION =
  'Play timed quizzes, real-time PvP arena matches, and career modes on Quizter Club. Earn XP, unlock achievements, climb leaderboards.';
